import styled from 'styled-components';
import { breakpoints } from 'theme';

export const StyledMessageSection = styled.section`
  position: relative;
  max-width: 720px;
  padding: 0px 40px;
  margin: auto;
  form textarea:last-of-type {
    margin-bottom: 14px;
  }

  @media ${breakpoints.downSmPlus} {
    padding-right: 30px;
  }
`;

export const StyledForm = styled.form`
  position: relative;
  @media ${breakpoints.downMd} {
    padding-left: 20px;
  }
  @media ${breakpoints.downSmPlus} {
    padding-left: 0px;
  }
`;

export const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

export const StyledOtherRecipientsTooltipTrigger = styled.div`
  width: 100%;
`;

export const StyledCheckboxWrapper = styled.div`
  position: absolute;
  top: -38px;
  right: 0;

  & > label {
    width: auto;
    font-size: 12px;
    color: #8298ab;
    font-weight: 600;
    padding-top: 1px;
  }
`;
